import { render, staticRenderFns } from "./ExcessAlert.vue?vue&type=template&id=9e407454&"
import script from "./ExcessAlert.vue?vue&type=script&lang=js&"
export * from "./ExcessAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports